module.exports = __webpack_public_path__ + "img/join-us-guanhuai.1a65c572.png";